const merge = require('lodash/merge');
const { apiPortfolioId } = require('../../utils');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

function getUrl(endpoint) {
  return `${baseUrl}${endpoint}`;
}

return {
  getResponseJson(portfolioId, screen, context, metaData) {
      const url = getUrl('send-rm-callback');
      const context_value = context.replace(/-/g, ' ');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };

      const body = {
        pfId: parsedMetaData.portfolio.pfRelId,
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        screen: screen,
        context:context_value,
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },

    getResponseJsonExtended(portfolioId, screen, context, investmentIdeaId, metaData) {
      const url = getUrl('send-rm-callback');
      const investmentIdea = investmentIdeaId.replace(/i/gi,'');
      const context_value = context.replace(/-/g, ' ');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };

      const body = {
        pfId: parsedMetaData.portfolio.pfRelId,
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        screen: screen,
        context:context_value,
        investmentIdeaId:investmentIdea
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    }

  
  };
}

module.exports = apiFactory;
